import React, { useEffect, useRef, useState } from "react";
import label from "../../labels/accessRightsManagement_en.json";
import _ from "lodash/fp";
import dayjs from "dayjs";

import commonLabels from "../../../common/labels/common_en.json";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { useForm, useWatch } from "react-hook-form";
import { getUserRoles } from "../../../common/actions/commonActions";
import {
  getAllApprovalUserList,
  getUserList,
  getUserListing,
  saveNewUserData,
} from "../../actions/accessRightsManagementActions";
import { getSupervisorlist } from "../../../postExaminationProcessObjective/actions/postExaminationProcessObjectiveActions";
import AbsenteeApprovalEntity from "../../../postExaminationProcessObjective/components/examReport/AbsenteeApprovalEntity";
import UserRegistrationEntity from "../../components/masterEntry/UserRegistrationEntity";
import TablePagination from "../../../common/components/TablePagination";
import DeleteUser from "./deleteUser";
import UpdateUser from "./updateUser";

const UserRegistration = () => {
  const { handleSubmit, errors, register, reset, watch } = useForm({
    mode: "onChange",
  });
  const [stepName, setName] = useState("UserRegistration");
  const [selectedDepartment, setSelectedDepartment] = useState("");
  const [selectedRole, setSelectedRole] = useState("");
  const [userName, setUserName] = useState("");
  const [email, setEmail] = useState("");
  const [mobile, setMobile] = useState("");
  const [password, setPassword] = useState("");
  const [reconfirmPassword, setReconfirmPassword] = useState("");
  const [reloadItem, setReloadItem] = useState(true);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [selectedSupervisior, setSupervisor] = useState("");
  const [deletedData, setDeletedData] = useState("");
  let [approvalEntityModal, setApprovalEntityModal] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showUpdateModal, setShowUpdateModal] = useState(false);
  let [selectedApprovalEntity, setSelectedApprovalEntity] = useState("");
  const [updatedValue, setUpdatedValue] = useState("");
  const [updatedDepartment, setUpdatedDepartment] = useState("");
  const [updatedRole, setUpdatedRole] = useState("");
  const [updatedtempDepartment, setUpdatedtempDepartment] = useState("");
  const [updatedFirstName, setUpdatedFirstName] = useState("");
  const [updatedLastName, setUpdatedLastName] = useState("");
  const [updatedUserName, setUpdatedUserName] = useState("");
  const [updatedEmail, setupdatedEmail] = useState("");
  const [updatedMobile, setUpdatedMobile] = useState("");

  const [updatedData, setUpdatedData] = useState({});
  const [checkboxData, setCheckBoxData] = useState(true);
  const [showoptions, setShowOptions] = useState(false);
  let [listCurrentPage, setListCurrentPage] = useState(0);
  const dispatch = useDispatch();
  let selectDept = useRef();
  useEffect(() => {
    window.scrollTo(0, 0);
    setReloadItem(!reloadItem);
  }, []);
  // allDepartments
  let rowPerPage = 10;
  let userRegistrationHeader = [
    "Status",
    "Updated On",
    "First Name",
    "Last Name",
    "Role",
    "Department",
    "Approver",
    "Comments By Approver",
    "Action",
  ];
  let userListingHeader = [
    "Sr. No.",
    "First Name",
    "Last Name",
    "Mobile",
    "Email",
    "Superadmin",
    // "IsActive",
    "Action",
  ];
  let { allDepartments } = useSelector((state) => state?.common, shallowEqual);
  let { userRolesList } = useSelector((state) => state?.common, shallowEqual);
  let { supervisorList } = useSelector(
    (state) => state.postExamProcessObjectReducer,
    shallowEqual
  );

  useEffect(() => {
    dispatch(getUserRoles());
    // dispatch(getSupervisorlist());
    dispatch(getUserListing());
  }, []);

  let { userListing, unapprovedUser_list, getUser } = useSelector(
    (state) => state?.accessRightsManagementReducer,
    shallowEqual
  );

  const session = JSON.parse(sessionStorage.getItem("session"));

  // useEffect(() => {
  //   if (showModal||deletedData) {
  //     dispatch(getUserList(listCurrentPage, rowPerPage));
  //   }
  // }, [showModal]);

  useEffect(() => {
    if (stepName === "UserList") {
      dispatch(getUserList(listCurrentPage, rowPerPage));
    }
  }, [stepName, listCurrentPage, rowPerPage, dispatch]);

  useEffect(() => {
    if (stepName === "unapproved") {
      dispatch(getAllApprovalUserList());
      setReloadItem(!reloadItem);
    }
  }, [stepName, dispatch]);

  // useEffect(() => {
  //   onCancelButton();
  // }, [stepName]);
  const onSelectDepartment = (ele) => {
    let selected = ele;
    setSelectedDepartment(ele);
    setSelectedRole("");
    setSupervisor("");
    setUserName("");
    setFirstName("");
    setLastName("");
    setEmail("");
    setMobile("");
    setPassword("");
    setReconfirmPassword("");
  };

  const onSelectRole = (ele) => {
    let selected = ele;
    setSelectedRole(ele);
    setSupervisor("");
    setUserName("");
    setFirstName("");
    setLastName("");
    setEmail("");
    setMobile("");
    setPassword("");
    setReconfirmPassword("");
  };

  const onSelectSupervisior = (ele) => {
    let selected = ele;
    setSupervisor(ele);
    setUserName("");
    setFirstName("");
    setLastName("");
    setEmail("");
    setMobile("");
    setPassword("");
    setReconfirmPassword("");
  };

  const onCancelButton = () => {
    reset();
    setReloadItem(!reloadItem);
  };
  // const value = updatedValue?.userDeptRole?.map((item, ind) => item) || [];
  // const userApprovalDeptRoleDto = value.map((item) => ({
  //   department: {
  //     id: parseInt(updatedDepartment) || item.department.id,
  //   },
  //   role: {
  //     id: item.role.id,
  //   },
  //   supervisor: {
  //     id: item.supervisor.id,
  //   },
  //   isActive: true,
  // }));

  const onSubmit = () => {
    // if (showoptions) {
    //   let data = {
    //     userApproval: {
    //       approvalType: "Edit User",
    //       status: "Approval1_Pending",

    //       userId: updatedValue?.user?.id,
    //       email: updatedEmail || updatedValue?.user?.email,
    //       mobile: updatedMobile || updatedValue?.user?.mobile,
    //       password: "Password@2",
    //       isSuperAdmin: "true",
    //       isActive: checkboxData || updatedValue?.user?.isActive,
    //       firstName: updatedFirstName || updatedValue?.user?.firstName,
    //       lastName: updatedLastName || updatedValue.user?.lastName,
    //     },
    //     userApprovalDeptRoleDto: userApprovalDeptRoleDto,
    //   };

    //   dispatch(saveNewUserData(data));

    // } else {
    let data = {
      userApproval: {
        approvalType: "New User",
        status: "Approval1_Pending",
        email: email,
        mobile: mobile,
        password: password,
        isSuperAdmin: "true",
        isActive: checkboxData,
        firstName: firstName,
        lastName: lastName,
      },
      userApprovalDeptRoleDto: [
        {
          department: {
            id: selectedDepartment,
          },
          role: {
            id: selectedRole,
          },
          supervisor: {
            id: selectedSupervisior,
          },
          isActive: true,
        },
      ],
    };

    dispatch(saveNewUserData(data));
    // setName("unapproved");
    // dispatch(getAllApprovalUserList());
    onCancelButton();
  };

  const handleApprovalUser = (ele) => {
    setSelectedApprovalEntity(ele);
    setApprovalEntityModal(true);
  };

  const deleteUser = (ele) => {
    setShowModal(true);
    setDeletedData(ele);
  };

  const editUser = (ele) => {
    let selected = ele;
    setShowUpdateModal(true);
    setUpdatedValue(selected);
    setShowOptions(true);
  };
  const onChangeDepartment = (e) => {
    setUpdatedDepartment(e.target.value);

    // dispatch(getUserRoles());
  };
  // useEffect(() => {
  //   setUpdatedDepartment(
  //     updatedValue?.userDeptRole &&
  //       updatedValue?.userDeptRole.length > 0 &&
  //       updatedValue?.userDeptRole[0]?.department?.id
  //   );
  // }, [updatedValue]);

  const onhandleisActive = (ele) => {
    setCheckBoxData(ele.target.checked);

  };

  const handleActive = (id, isActive) => {
    let data = {
      id: id,
      isActive: !isActive,
    };
    dispatch(saveNewUserData(data));
  }
  return (
    <div className="dashboardContentArea">
      <h5 className="labelMargin"> {label.UserRegistration} </h5>
      <div
        className="tab-content border border-light myTabContent"
        id="myTabContentContainer"
      >
        <ul className="nav nav-tabs" id="myTab" role="tablist">
          <li className="nav-item" key="0">
            <a
              href="#"
              className={
                stepName === "UserRegistration"
                  ? "nav-link active"
                  : "nav-link bg-profile-tabs"
              }
              value="UserRegistration"
              id="UserRegistration-tab"
              onClick={() => setName("UserRegistration")}
              data-toggle="tab"
              role="tab"
              aria-controls="UserRegistration"
              aria-selected="false"
            >
              <span>{label.UserRegistration}</span>
            </a>
          </li>
          <li className="nav-item" key="0">
            <a
              href="#"
              className={
                stepName === "unapproved"
                  ? "nav-link active"
                  : "nav-link bg-profile-tabs"
              }
              value="unapproved"
              id="unapproved-tab"
              onClick={() => setName("unapproved")}
              data-toggle="tab"
              role="tab"
              aria-controls="unapproved"
              aria-selected="false"
            >
              <span>{label.Unapproved}</span>
            </a>
          </li>
          <li className="nav-item" key="1">
            <a
              href="#"
              className={
                stepName === "UserList"
                  ? "nav-link active"
                  : "nav-link bg-profile-tabs"
              }
              value="UserList"
              id="UserList-tab"
              onClick={() => setName("UserList")}
              data-toggle="tab"
              role="tab"
              aria-controls="UserList"
              aria-selected="false"
            >
              <span>{label.UserList}</span>
            </a>
          </li>
        </ul>
        <div className="tab-content border border-light" id="myTabContent">
          <div
            className={
              stepName === "UserRegistration"
                ? "tab-pane fade show active"
                : "tab-pane fade styled-tab"
            }
            id="UserRegistration"
            role="tabpanel"
            aria-labelledby="list-tab"
          >
            <div className="row dashboardCards">
              <div className="col-md-12">
                <form name="UserRegistrationForm" encType="multipart/form-data">
                  <div className="form-group">
                    <div className="row">
                      <div className="col-md-3">
                        <label className="float-left">
                          {label.Department}
                          <span className="errorText">*</span>
                        </label>

                        <select
                          className="form-control"
                          name="departmentName"
                          // disabled={showoptions}

                          ref={register({ required: true })}
                          onChange={(e) => {
                            onSelectDepartment(e.target.value);
                          }}
                        >
                          <option key={0} value="">
                            {commonLabels.COMBO_SELECT}
                          </option>
                          {allDepartments &&
                            allDepartments.length > 0 &&
                            allDepartments.map((element, index) => (
                              <option key={index} value={element.id}>
                                {element.name}
                              </option>
                            ))}
                        </select>

                        {_.get("departmentName.type", errors) ===
                          "required" && (
                            <p className="errorText float-left">
                              {commonLabels.MANDATORY_FIELD_MESSAGE}
                            </p>
                          )}
                      </div>

                      <div className="col-md-3">
                        <label className="float-left">
                          {label.Authority}
                          <span className="errorText">*</span>
                        </label>

                        <select
                          className="form-control"
                          name="role"
                          // disabled={showoptions}

                          ref={register({ required: true })}
                          onChange={(e) => {
                            onSelectRole(e.target.value);
                          }}
                        >
                          <option key={0} value="">
                            {commonLabels.COMBO_SELECT}
                          </option>
                          {userRolesList &&
                            userRolesList.length > 0 &&
                            userRolesList.map((element, index) => (
                              <option key={index} value={element.id}>
                                {element.name}
                              </option>
                            ))}
                        </select>

                        {_.get("role.type", errors) === "required" && (
                          <p className="errorText float-left">
                            {commonLabels.MANDATORY_FIELD_MESSAGE}
                          </p>
                        )}
                      </div>

                      <div className="col-md-3">
                        <label className="float-left">
                          {label.Supervisior}
                          <span className="errorText">*</span>
                        </label>

                        <select
                          className="form-control"
                          name="supervisior"
                          // disabled={showoptions}

                          // ref={register({ required: true })}
                          onChange={(e) => {
                            onSelectSupervisior(e.target.value);
                          }}
                        >
                          <option key={0} value="">
                            {commonLabels.COMBO_SELECT}
                          </option>
                          {getUser &&
                            getUser.length > 0 &&
                            getUser.map((element, index) => (
                              <option key={index} value={element.id}>
                                {element.firstName + " " + element.lastName}
                              </option>
                            ))}
                        </select>

                        {/* {_.get("supervisior.type", errors) === "required" && (
                          <p className="errorText float-left">
                            {commonLabels.MANDATORY_FIELD_MESSAGE}
                          </p>
                        )} */}
                      </div>

                      {/* <div className="col-md-3">
                        <label className="float-left">
                          {label.UserName}
                          <span className="errorText">*</span>
                        </label>
                        <input
                          type="text"
                          name="userName"
                          onChange={(e) => {
                            if (showoptions) {
                              setUpdatedUserName(e.target.value);
                            } else {
                              setUserName(e.target.value);
                            }
                          }}
                          Value={updatedValue.username}
                          className="form-control"
                          maxLength={25}
                          pattern="[A-Za-z]+"
                          ref={register({
                            required: true,
                            pattern: /^[A-Za-z]+( [A-Za-z]+)*$/,
                          })}
                        />
                        {_.get("userName.type", errors) === "required" && (
                          <p className="errorText float-left">
                            {commonLabels.MANDATORY_FIELD_MESSAGE}
                          </p>
                        )}
                        {_.get("userName.type", errors) === "pattern" && (
                          <p className="errorText float-left">
                            {commonLabels.Onlyalphabeticcharactersareallowed}
                          </p>
                        )}
                      </div> */}
                      {/* </div>

                    <div className="row"> */}
                      <div className="col-md-3">
                        <label className="float-left">
                          {label.firstName}
                          <span className="errorText">*</span>
                        </label>
                        <input
                          type="text"
                          name="firstName"
                          // defaultValue={updatedValue?.user?.firstName || ""}
                          onChange={(e) => {
                            setFirstName(e.target.value);
                          }}
                          className="form-control"
                          maxLength={15}
                          pattern="[A-Za-z]+"
                          ref={register({
                            required: true,
                            pattern: /^[A-Za-z]+( [A-Za-z]+)*$/,
                          })}
                        />
                        {_.get("firstName.type", errors) === "required" && (
                          <p className="errorText float-left">
                            {commonLabels.MANDATORY_FIELD_MESSAGE}
                          </p>
                        )}
                        {_.get("firstName.type", errors) === "pattern" && (
                          <p className="errorText float-left">
                            {commonLabels.Onlyalphabeticcharactersareallowed}
                          </p>
                        )}
                      </div>

                      <div className="col-md-3">
                        <label className="float-left">
                          {label.lastName}
                          <span className="errorText">*</span>
                        </label>
                        <input
                          type="text"
                          name="lastName"
                          // defaultValue={updatedValue?.user?.lastName}
                          onChange={(e) => {
                            setLastName(e.target.value);
                          }}
                          className="form-control"
                          maxLength={25}
                          pattern="[A-Za-z]+"
                          ref={register({
                            required: true,
                            pattern: /^[A-Za-z]+( [A-Za-z]+)*$/,
                          })}
                        />
                        {_.get("lastName.type", errors) === "required" && (
                          <p className="errorText float-left">
                            {commonLabels.MANDATORY_FIELD_MESSAGE}
                          </p>
                        )}
                        {_.get("lastName.type", errors) === "pattern" && (
                          <p className="errorText float-left">
                            {commonLabels.Onlyalphabeticcharactersareallowed}
                          </p>
                        )}
                      </div>
                      <div className="col-md-3">
                        <label className="float-left">
                          {label.UserEmailId}
                          <span className="errorText">*</span>
                        </label>
                        <input
                          type="text"
                          name="email"
                          // defaultValue={updatedValue?.user?.email}
                          onChange={(e) => {
                            setEmail(e.target.value);
                          }}
                          className="form-control"
                          ref={register({
                            required: true,
                            pattern:
                              /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Z|a-z]{2,}$/,
                          })}
                        />
                        {_.get("email.type", errors) === "required" && (
                          <p className="errorText float-left">
                            {commonLabels.MANDATORY_FIELD_MESSAGE}
                          </p>
                        )}
                        {_.get("email.type", errors) === "pattern" && (
                          <p className="errorText float-left">
                            {commonLabels.Invalidemailaddress}
                          </p>
                        )}
                      </div>
                      <div className="col-md-3">
                        <label className="float-left">
                          {label.Usermobile}
                          <span className="errorText">*</span>
                        </label>
                        <input
                          type="text"
                          name="Usermobile"
                          // defaultValue={updatedValue?.user?.mobile}
                          onChange={(e) => {
                            setMobile(e.target.value);
                          }}
                          className="form-control"
                          maxLength={10}
                          ref={register({
                            required: true,
                            pattern: /^[6-9][0-9]{9}$/,
                          })}
                        />
                        {_.get("Usermobile.type", errors) === "required" && (
                          <p className="errorText float-left">
                            {commonLabels.MANDATORY_FIELD_MESSAGE}
                          </p>
                        )}
                        {_.get("Usermobile.type", errors) === "pattern" && (
                          <p className="errorText float-left">
                            {
                              commonLabels.Pleaseenteravalid10digitmobilenumberstartingwith678or9
                            }
                          </p>
                        )}
                      </div>
                      <div className="col-md-3">
                        <label className="float-left">
                          {label.Password}
                          <span className="errorText">*</span>
                        </label>
                        <input
                          type="password"
                          name="Password"
                          onChange={(e) => {
                            setPassword(e.target.value);
                          }}
                          className="form-control"
                          minLength={8}
                          maxLength={15}
                          ref={register({
                            required: true,
                            pattern:
                              /^(?=.*[A-Z])(?=.*[a-z].*[a-z])(?=.*[0-9])(?=.*[!@#$%^&*]).{8,15}$/,
                          })}
                        />
                        {_.get("Password.type", errors) === "required" && (
                          <p className="errorText float-left">
                            {commonLabels.MANDATORY_FIELD_MESSAGE}
                          </p>
                        )}
                        {_.get("Password.type", errors) === "pattern" && (
                          <p className="errorText float-left">
                            Please enter a valid password with a minimum of 8
                            characters, including at least one uppercase letter,
                            more than one lowercase letter, and mixed with
                            numbers and special characters.
                          </p>
                        )}
                      </div>

                      <div className="col-md-3">
                        <label className="float-left">
                          {label.ReconfirmPassword}
                          <span className="errorText">*</span>
                        </label>
                        <input
                          type="password"
                          name="ReconfirmPassword"
                          onChange={(e) => {
                            setReconfirmPassword(e.target.value);
                          }}
                          minLength={8}
                          maxLength={15}
                          className="form-control"
                          ref={register({
                            required: true,
                            validate: (value) =>
                              value === watch("Password") ||
                              "Passwords do not match.",
                          })}
                        />
                        {_.get("ReconfirmPassword.type", errors) ===
                          "required" && (
                            <p className="errorText float-left">
                              {commonLabels.MANDATORY_FIELD_MESSAGE}
                            </p>
                          )}
                        {_.get("ReconfirmPassword.type", errors) ===
                          "validate" && (
                            <p className="errorText float-left">
                              {errors.ReconfirmPassword.message}
                            </p>
                          )}
                      </div>

                      <div className="col-md-3">
                        <label className="float-left">
                          {label.isActive}
                          <span className="errorText">*</span>
                        </label>
                        <input
                          type="checkbox"
                          id="isActive"
                          name="isActive"
                          defaultChecked={updatedValue?.user?.isActive}
                          // className="form-control"
                          // ref={register({ required: true })}
                          checked={checkboxData}
                          onChange={(event) => onhandleisActive(event)}
                        />
                      </div>
                    </div>
                    <div className="row">
                      <div className="form-group col-md-6 ">
                        {(session.roleName === "superadmin" ||
                          session.roleName === "admin") && (
                            <>
                              <button
                                type="reset"
                                className="btn btn-secondary mr-2 mt-10 ml-10"
                                onClick={() => onCancelButton()}
                              >
                                {commonLabels.BUTTON_CANCEL}
                              </button>
                              <button
                                type="button"
                                className="btn btn-primary   mr-2 mt-10"
                                onClick={handleSubmit((e) => {
                                  onSubmit(e);
                                })}
                              >
                                {commonLabels.BUTTON_SAVE}
                              </button>{" "}
                            </>
                          )}
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <div
            className={
              stepName === "unapproved"
                ? "tab-pane fade show active"
                : "tab-pane fade styled-tab"
            }
            id="unapproved"
            role="tabpanel"
            aria-labelledby="unapproved-tab"
          >
            {unapprovedUser_list &&
              unapprovedUser_list.pendingApprovals &&
              unapprovedUser_list.pendingApprovals.length > 0 ? (
              <>
                <table className="table table-bordered">
                  <thead className="thead-light">
                    <tr>
                      {userRegistrationHeader &&
                        userRegistrationHeader.map((itm, ind) => (
                          <th
                            key={ind}
                            className={`${itm === "Action" ? "text-center" : ""
                              }`}
                          >
                            {itm}
                          </th>
                        ))}
                    </tr>
                  </thead>
                  <tbody>
                    {unapprovedUser_list &&
                      unapprovedUser_list.pendingApprovals &&
                      unapprovedUser_list.pendingApprovals.length > 0 &&
                      unapprovedUser_list.pendingApprovals.map((ele, index) => {
                        return (
                          <tr key={index}>
                            <td className="w-8 ">{ele.userApproval.status}</td>
                            <td className="word-break">
                              {ele.updatedOn
                                ? dayjs(ele.updatedOn).format(
                                  "DD/MM/YYYY h:mm A"
                                )
                                : ""}
                            </td>
                            <td className=" w-10">
                              {ele.userApproval.firstName}
                            </td>

                            <td className=" w-10 word-break">
                              {ele.userApproval.lastName}
                            </td>
                            <td className="w-10 word-break width-12">
                              {ele.roleName}
                            </td>
                            <td>{ele.departmentName}</td>

                            <td className=" word-break">{ele.lastApprover}</td>
                            <td className=" word-break">
                              {ele.lastApproverComments}
                            </td>

                            <td className=" word-break width-15">
                              {(session.roleName == "superadmin" ||
                                session.roleName == "desk officer") && (
                                  <button
                                    type="button"
                                    className="mx-auto btn btn-outline-primary btn-sm custom-button"
                                    onClick={() => {
                                      handleApprovalUser(ele);
                                    }}
                                  >
                                    {label.Review}
                                  </button>
                                )}
                            </td>
                          </tr>
                        );
                      })}
                  </tbody>
                </table>
              </>
            ) : (
              <div className="text-center">
                <font className="text-danger">
                  {commonLabels.NO_DATA_FOUND}
                </font>
              </div>
            )}
          </div>

          <div
            className={
              stepName === "UserList"
                ? "tab-pane fade show active"
                : "tab-pane fade styled-tab"
            }
            id="UserList"
            role="tabpanel"
            aria-labelledby="UserList-tab"
          >
            <div className="row dashboardCards">
              <div className="col-md-12">
                {userListing &&
                  (userListing.totalNoOfRecords || userListing.length) > 0 ? (
                  <>
                    <table className="table table-bordered">
                      <thead className="thead-light">
                        <tr>
                          {userListingHeader &&
                            userListingHeader.map((itm, ind) => (
                              <th
                                key={ind}
                                className={`${itm === "Sr.No." || itm === "Action"
                                  ? "text-center"
                                  : ""
                                  }`}
                              >
                                {itm}
                              </th>
                            ))}
                        </tr>
                      </thead>
                      <tbody>
                        {userListing &&
                          userListing.userList &&
                          (userListing.totalNoOfRecords || userListing.length) >
                          0 &&
                          userListing.userList.map((ele, index) => {
                            return (
                              <tr key={index}>
                                <td className="w-5 text-center ">
                                  {index + 1}
                                </td>
                                <td className="w-10  ">{ele.user.firstName}</td>
                                <td className=" word-break width-10">
                                  {ele.user.lastName}
                                </td>
                                <td className=" width-10">{ele.user.mobile}</td>
                                <td className=" word-break width-30">
                                  {ele.user.email}
                                </td>

                                {/* <td className="text-centerw-10 word-break  text-center width-10">
                                  {ele.username}
                                </td> */}
                                <td className="w-10 word-break  width-5">
                                  {ele.user.isSuperAdmin === true ? "Yes" : "No"}
                                </td>
                                {/* <td className="w-10 word-breakwidth-5">
                                  {ele.user.isActive === true ? "Yes" : "No"}
                                </td> */}
                                {/* <td className="text-center w-10">
                                  <div className="d-flex">
                                    <button
                                      type="button"
                                      className="btn btn-primary mr-2"
                                      onClick={() => editUser(ele)}
                                    >
                                      Edit
                                    </button>
                                    <button
                                      type="button"
                                      className="btn btn-primary "
                                      onClick={() => deleteUser(ele)}
                                    >
                                      Delete
                                    </button>
                                  </div>
                                </td> */}
                                <td className="col-2 text-center">
                                  <i
                                    role="button"
                                    data-toggle="tooltip"
                                    title="Edit"
                                    className={"text-primary fa fa-edit fa-lg"}
                                    onClick={() => editUser(ele)}
                                  ></i>
                                  &nbsp;&nbsp;
                                  <i role="button"
                                    data-toggle="tooltip"
                                    title={ele.user.isActive ? commonLabels.BUTTON_INACTIVE : commonLabels.BUTTON_ACTIVE}
                                    className={ele.user.isActive === true ? "text-success fa fa-toggle-on fa-lg" : "text-danger fa fa-toggle-off fa-lg"}
                                    onClick={() => { handleActive(ele.user.id, ele.user.isActive); }}>
                                  </i>
                                  {/* &nbsp;&nbsp;
                                  <i
                                    role="button"
                                    data-toggle="tooltip"
                                    title="Delete"
                                    className={"text-danger fa fa-trash fa-lg"}
                                    onClick={() => deleteUser(ele)}
                                  ></i> */}
                                </td>
                              </tr>
                            );
                          })}
                      </tbody>
                    </table>
                    <TablePagination
                      paginationFor="user_listing"
                      rowPerPage={rowPerPage}
                      setListCurrentPage={setListCurrentPage}
                      totalCount={userListing.totalNoOfRecords}
                    />
                  </>
                ) : (
                  <div className="text-center">
                    <font className="text-danger">
                      {commonLabels.NO_DATA_FOUND}
                    </font>
                  </div>
                )}
              </div>
            </div>
          </div>
          {approvalEntityModal && (
            <UserRegistrationEntity
              stepName={stepName}
              setName={setName}
              showModal={approvalEntityModal}
              setShowModal={setApprovalEntityModal}
              setSelectedApprovalEntity={selectedApprovalEntity}
            />
          )}
          {showModal && (
            <DeleteUser
              showModal={showModal}
              setShowModal={setShowModal}
              setDeletedData={deletedData}
            />
          )}
          {showUpdateModal && (
            <UpdateUser
              showUpdateModal={showUpdateModal}
              setShowUpdateModal={setShowUpdateModal}
              setUpdatedValue={updatedValue}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default UserRegistration;
